/* ==========================================================================
   Elevate Floors — FAQ

   Uma responsabilidade: abrir e fechar cada pergunta.

   As perguntas abrem de forma INDEPENDENTE, e isso diverge do resto do site de
   propósito. Nas páginas de serviço o acordeão de três itens é argumentação, e
   abrir um por vez guia a leitura. Aqui são 14 respostas de consulta: a pessoa
   compara, volta, relê. Fechar a anterior a cada clique seria hostil.
   Não "padronizar" isso depois.

   O estado vive só no aria-expanded do botão: o CSS lê o atributo, o JS
   escreve. Sem estado central para dessincronizar.
   ========================================================================== */
(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.ef-faq__q').forEach(function (btn) {
      if (btn._efFaqBound) return;
      btn._efFaqBound = true;

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
